<ion-grid>
  <tidy-menu-header [menuData]="menuData" (click)="changeState()" />
  @if (menuData) {
    <tidy-menu-address-selector [menuData]="menuData" [ngClass]="{'hide': !menuData?.openState}" />
  }
  <tidy-menu-top-buttons [ngClass]="{'hide': menuData?.openState}" [menuData]="menuData" />
  <tidy-missing-field [ngClass]="{'hide': menuData?.openState}" />
  <tidy-menu-bottom-buttons [ngClass]="{'hide': menuData?.openState}" [menuData]="menuData" />
</ion-grid>
